import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export interface SiarProvince {
  id: string | number;
  name: string;
}

export interface SiarStation {
  id: string | number;
  name: string;
  provinceId?: string | number | null;
}

@Injectable({
  providedIn: 'root'
})
export class SiarStationsService {
  private stationsByProvinceCache = new Map<string, Observable<SiarStation[]>>();

  constructor(private $http: SuperHttpClientProvider) {}

  getProvinces(): Observable<SiarProvince[]> {
    return this.$http.default
      .get('/admin/siar/provinces')
      .pipe(map((response: any) => response?.provinces || []));
  }

  getStationsByProvince(
    provinceId: string | number
  ): Observable<SiarStation[]> {
    const key = String(provinceId ?? '');
    if (!this.stationsByProvinceCache.has(key)) {
      const request$ = this.$http.default
        .get('/admin/siar/stations', { params: { provinceId } })
        .pipe(
          map((response: any) => response?.stations || []),
          shareReplay(1),
          catchError(error => {
            this.stationsByProvinceCache.delete(key);
            return throwError(() => error);
          })
        );
      this.stationsByProvinceCache.set(key, request$);
    }
    return this.stationsByProvinceCache.get(key) as Observable<SiarStation[]>;
  }
}
